import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateCreateActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    create: generateCreateActionCreator(`${routes.API_INVOICE}/order`, ACTION_NAMES.INVOICE),
    readOne: generateReadOneActionCreator(routes.API_INVOICE, ACTION_NAMES.INVOICE),
    read: generateReadOneActionCreator(`${routes.API_INVOICE}/account`, ACTION_NAMES.ACCOUNT_INVOICES),
    pay: generateUpdateActionCreator(routes.API_INVOICE, ACTION_NAMES.INVOICE),
    logInvoiceChange: generateCreateActionCreator(routes.API_INVOICE, ACTION_NAMES.LOG_INVOICE_CHANGE),
    getInvoiceChangeLog: generateReadOneActionCreator(`${routes.API_INVOICE}/logs`, ACTION_NAMES.LOG_INVOICE_CHANGE)
}
